import styled, { css } from 'styled-components';
import { switchProp, ifProp } from 'styled-tools';
import { layout, colors } from '@prisjakt/ui-base';

// eslint-disable-next-line import/prefer-default-export
export const PriceLabel = styled.span.attrs({ 'data-test': 'PriceLabel' })`
  font-size: ${p => (p.medium ? '16px' : 'inherit')};
  font-weight: ${p => (p.bold ? 'bold' : 'inherit')};

  ${ifProp(
    'campaign',
    css`
      padding: 0 4px;
      border-radius: ${layout.borderRadius};
    `
  )};

  ${switchProp('styling', {
    primary: css`
      color: ${colors.red1};
    `,
    secondary: css`
      color: ${colors.darkGray4};
    `,
    lighten: css`
      color: ${colors.darkGray2};
    `,
  })}
`;
